/**
 * The Figma spacing scale (`space/*`), by token number: space/N = N x 4px.
 * Layout props take these values, so a gap can only ever be an on-system gap.
 * Component internals favour 1-4 (4-16px); layout sections favour 6-24 (24-96px).
 */
export const SPACE = [0, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 16, 20, 24] as const;

export type Space = (typeof SPACE)[number];

/**
 * `gap-*` per token, written out in full: Tailwind finds classes by scanning
 * source for complete strings, so a template like `gap-${n}` would never be
 * generated.
 */
export const gapClass = {
  0: 'gap-0',
  0.5: 'gap-0.5',
  1: 'gap-1',
  1.5: 'gap-1.5',
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  5: 'gap-5',
  6: 'gap-6',
  8: 'gap-8',
  10: 'gap-10',
  12: 'gap-12',
  16: 'gap-16',
  20: 'gap-20',
  24: 'gap-24',
} as const satisfies Record<Space, string>;
